import React from "react";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "popper.js/dist/umd/popper.min.js";

import Login from "./pages/login/Login";
import Registration from "./pages/registration/Registration";
import ViewRegistration from "./pages/registration/ViewRegistration";


import { Redirect } from "react-router-dom";
import { BrowserRouter, Route } from "react-router-dom";

export default function Router() {
  return (
    <BrowserRouter>
      <Route exact path="/login" component={Login} />


      <Route exact path="/" component={Registration} />
      <Route
        exact
        path="/view"
        component={ViewRegistration}
      />



      {/* <Route render={() => <Redirect to={{ pathname: "/" }} />} /> */}
    </BrowserRouter>
  );
}
